import Env from './Env';

export interface SmtpMessage{
    from: string,
    subject: string,
    body: string,
    name?: string | any
}

export default class SmtpSender{

    private static to =  Env.officeEmail

    private static username = Env.smtpUsername;
    private static password = Env.smtpPassword;

    static async sendSmtp(message: SmtpMessage) {

        const response = await window.Email.send({
            Host : "smtp-relay.sendinblue.com",
            Port: '587',
            Username : this.username,
            Password : this.password,

            To : Env.officeEmail,
            From : message.from,
            Subject : message.subject,
            Body : ` 
            <h3>Sent from Soeko contact from: ${window.location.href}</h3>
            <b>From: </b> <span>${message.name || message.from}</span> <br />
            <b>Body: </b>
            <p>
             ${message.body}
            </p>
            `
        });

        if(! response.toLowerCase().includes('ok')) throw new Error(response);
    }

    static async openMailBox(message: SmtpMessage) {

        await new Promise(r => setTimeout(r, 1000));
        const url = `mailto:${this.to}?subject=${message.subject}&body=${message.body}&from=${message.from}&name=${message.name}`;
        // console.log(url)
        window.open(url)
    }
}